import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";
const Tooltip = ({tag, children, ...rest}) => {
  const TooltipWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  margin-left: ${rest.tooltipId === "tooltip-1" ? "-25px" : rest.tooltipId === "tooltip-2" ? "-350px" : "-675px"};
  padding-top: 55px;
  width: 750px;
  transition: display 0.2s ease;
  display: ${rest.tooltipDisplay ? "block": "none"};
  z-index: 1000;

  > div {
    position: relative;
    background: #b9cde6;
    padding: 20px;
    box-shadow: 0 0 5px 0 rgba(0,0,0,.25);

    &:before{
      content: '';
      position: absolute;
      top: -20px;
      left: ${rest.tooltipId === "tooltip-1"? "calc(17% - 40px)": rest.tooltipId === "tooltip-2"? "calc(55% - 40px)":"calc(92% - 20px)"};
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-bottom: 30px solid #b9cde6;
    }
  }`;
  
    return (
        <TooltipWrapper
        className={`${rest.classList} usa-tooltip`}
        data-position={rest.dataPosition}
        tooltipId={rest.tooltipId}
      >
        <div>
        {children}
        </div>
      </TooltipWrapper>
    )
}

Tooltip.propTypes = { 
    tooltipId: propTypes.oneOfType([propTypes.string]),
    classList: propTypes.oneOfType([propTypes.string]),
    dataPosition: propTypes.oneOf(["top", "left", "right", "bottom"])
}
Tooltip.defaultProps = {
    tooltipId: '',
    classList: '',
    dataPosition: 'bottom'
}

export default Tooltip;
